import { useDispatch, useSelector } from "react-redux";
import {
  locationRequest,
  locationSuccess,
  locationFailure,
} from "../Store/Slices/locationSlice";

const useGeoLocation = () => {
  const dispatch = useDispatch();
  const { lat, lng, status } = useSelector((s) => s.location);

  const permissionDenied = status === "error";

  const fetchLocation = () => {
    // ⛔ Already have location → dobara mat lo
    if (lat && lng) return;

    if (!navigator.geolocation) {
      dispatch(locationFailure("Geolocation not supported"));
      return;
    }

    dispatch(locationRequest());

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        dispatch(
          locationSuccess({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          })
        );
      },
      (err) => {
        dispatch(locationFailure(err.message));
      }
    );
  };

  return {
    location: lat && lng ? { lat, lng } : null,
    permissionDenied,
    fetchLocation,
  };
};

export default useGeoLocation;
